/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';
import { useWatch } from 'react-hook-form';
import { Modal, Button } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { toast } from 'react-toastify';
import styles from './PaymentSettingsModal.module.scss';

function PaymentSettingsModal({ show, onHide, register, onSubmit, control, webhookUrl, loading }) {
  const feeType = useWatch({
    control,
    name: 'feeType',
  });
  const feeFor = useWatch({ control, name: 'feeFor' });

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      aria-labelledby="contained-modal-title-vcenter"
      className={`${styles.pay_modal} pay_modal`}
    >
      <Modal.Header className={`${styles.pay_modal_hd} pay_modal_hd`}>
        <Modal.Title id="contained-modal-title-vcenter">Payment Settings</Modal.Title>
        <Button onClick={onHide}>
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.6665 1.33333L14.9998 14.6667M1.6665 14.6667L14.9998 1.33333"
              stroke="#FF0000"
              strokeWidth="2.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Button>
      </Modal.Header>
      <Modal.Body className={`${styles.pay_body} pay_body`}>
        {/* <div className={styles.form_group}>
          <label>Publishable Key</label>
        </div> */}
        <Form onSubmit={onSubmit} className={styles.pay_body_form}>
          <Form.Group className={`${styles.pay_form_grp} pay_form_grp`} controlId="PublishableKey">
            <Form.Label className={`${styles.pay_label} pay_label`}>Publishable Key</Form.Label>
            <Form.Control
              className={`${styles.pay_input} pay_input`}
              type="text"
              placeholder="Enter Publishable Key"
              {...register('publishablekey')}
            />
          </Form.Group>
          <Form.Group className={`${styles.pay_form_grp} pay_form_grp`} controlId="SecretKey">
            <Form.Label className={`${styles.pay_label} pay_label`}>Secret Key</Form.Label>
            <Form.Control
              className={`${styles.pay_input} pay_input`}
              type="text"
              placeholder="Enter Secret Key"
              {...register('secretKey')}
            />
          </Form.Group>
          <Form.Group className={`${styles.pay_form_grp} pay_form_grp`} controlId="WebhookURL">
            <Form.Label className={`${styles.pay_label} pay_label`}>Webhook URL</Form.Label>
            <Form.Control
              className={`${styles.pay_input} ${styles.pay_input_copy} pay_input`}
              type="text"
              readOnly
              value={webhookUrl}
              placeholder="Enter Webhook Webhook URL"
            />
            <Button
              className={styles.copy_btn}
              onClick={() => {
                if (webhookUrl) {
                  navigator.clipboard
                    .writeText(webhookUrl)
                    .then(() => {
                      toast.success('Copied to clipboard!');
                    })
                    .catch((err) => {
                      console.error('Failed to copy: ', err);
                    });
                }
              }}
            >
              <svg
                width="17"
                height="20"
                viewBox="0 0 17 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.6484 20H3.1875C1.46432 20 0.0625 18.5982 0.0625 16.875V6.28906C0.0625 4.56589 1.46432 3.16406 3.1875 3.16406H10.6484C12.3716 3.16406 13.7734 4.56589 13.7734 6.28906V16.875C13.7734 18.5982 12.3716 20 10.6484 20ZM3.1875 4.72656C2.32599 4.72656 1.625 5.42755 1.625 6.28906V16.875C1.625 17.7365 2.32599 18.4375 3.1875 18.4375H10.6484C11.5099 18.4375 12.2109 17.7365 12.2109 16.875V6.28906C12.2109 5.42755 11.5099 4.72656 10.6484 4.72656H3.1875ZM16.8984 14.9219V3.125C16.8984 1.40182 15.4966 0 13.7734 0H5.10156C4.67004 0 4.32031 0.349731 4.32031 0.78125C4.32031 1.21277 4.67004 1.5625 5.10156 1.5625H13.7734C14.6349 1.5625 15.3359 2.26349 15.3359 3.125V14.9219C15.3359 15.3534 15.6857 15.7031 16.1172 15.7031C16.5487 15.7031 16.8984 15.3534 16.8984 14.9219Z"
                  fill="#727272"
                />
              </svg>
            </Button>
          </Form.Group>
          <Form.Group
            className={`${styles.pay_form_grp} pay_form_grp`}
            controlId="WebhookSecretKey"
          >
            <Form.Label className={`${styles.pay_label} pay_label`}>Webhook Secret Key</Form.Label>
            <Form.Control
              className={`${styles.pay_input} pay_input`}
              type="text"
              placeholder="Enter Webhook Secret Key"
              {...register('webhookSecretKey')}
            />
          </Form.Group>
          {/* <Form.Group className={`${styles.pay_form_grp} pay_form_grp`} controlId="ConvenienceFee">
            <Form.Label className={`${styles.pay_label} pay_label`}>Convenience Fee (%)</Form.Label>
            <Form.Control
              className={`${styles.pay_input} pay_input`}
              type="text"
              placeholder="Select Convenience Fee"
            />
          </Form.Group> */}
          <Form.Group className={`${styles.pay_form_grp} pay_form_grp`} controlId="ConvenienceFee">
            <Form.Label className={`${styles.pay_label} pay_label`}>Convenience Fee</Form.Label>

            <div className={styles.apply_contain}>
              <div className={styles.apply_hd}>Apply Fee</div>
              <form className={styles.custm_radio}>
                <p>
                  <input
                    type="radio"
                    id="percentage"
                    value="percentage"
                    {...register('feeType')}
                    checked={feeType === 'percentage'}
                  />
                  <Form.Label htmlFor="percentage">Percentage</Form.Label>
                </p>
                <p>
                  <input
                    type="radio"
                    id="flat"
                    value="flat"
                    checked={feeType === 'flat'}
                    {...register('feeType')}
                  />
                  <Form.Label htmlFor="flat">Flat</Form.Label>
                </p>
                <p>
                  <input
                    type="radio"
                    id="both"
                    value="both"
                    checked={feeType === 'both'}
                    {...register('feeType')}
                  />
                  <Form.Label htmlFor="both">Both</Form.Label>
                </p>
              </form>
            </div>

            {feeType === 'percentage' && (
              <Form.Select
                className={`${styles.pay_input} pay_input`}
                defaultValue=""
                {...register('convinienceFee')}
              >
                <option value="" disabled>
                  Select Convenience Fee
                </option>
                {Array.from({ length: 30 }, (_, i) => {
                  const value = 0.5 + i * 0.5;
                  return (
                    <option key={value} value={value}>
                      {value}%
                    </option>
                  );
                })}
              </Form.Select>
            )}

            {feeType === 'flat' && (
              <div className={styles.flat_amount}>
                <span>$</span>
                <Form.Control
                  className={`${styles.pay_input} pay_input`}
                  type="text"
                  placeholder="Enter Amount"
                  {...register('convinienceFee')}
                />
              </div>
            )}

            {feeType === 'both' && (
              <div className={styles.both_fee_fields}>
                <Form.Label className={`${styles.pay_sub_label} pay_sub_label`}>
                  Percentage (%)
                </Form.Label>
                <Form.Select
                  className={`${styles.pay_input} pay_input`}
                  defaultValue=""
                  {...register('convinienceFee')}
                >
                  <option value="" disabled>
                    Select percentage
                  </option>
                  {Array.from({ length: 30 }, (_, i) => {
                    const value = 0.5 + i * 0.5;
                    return (
                      <option key={value} value={value}>
                        {value}%
                      </option>
                    );
                  })}
                </Form.Select>

                <Form.Label className={`${styles.pay_sub_label} pay_sub_label`}>
                  Flat Amount ($)
                </Form.Label>
                <div className={styles.flat_amount}>
                  <span>$</span>
                  <Form.Control
                    className={`${styles.pay_input} pay_input`}
                    type="text"
                    placeholder="Enter flat amount"
                    {...register('extraFee')}
                  />
                </div>
              </div>
            )}
          </Form.Group>
          <Form.Group className={`${styles.pay_form_grp} pay_form_grp`}>
            <Form.Label className={`${styles.pay_label} pay_label`}>Fee Type</Form.Label>
            <div className={styles.apply_contain}>
              <form className={styles.custm_radio}>
                <p>
                  <input
                    type="radio"
                    id="seat"
                    name="radio-group"
                    value="per person"
                    {...register('feeFor')}
                    checked={feeFor === 'per person'}
                  />
                  <Form.Label for="seat">Per Person or Seat</Form.Label>
                </p>
                <p>
                  <input
                    type="radio"
                    id="perbooking"
                    name="radio-group"
                    value="per booking"
                    {...register('feeFor')}
                    checked={feeFor === 'per booking'}
                  />
                  <Form.Label for="perbooking">Per Booking</Form.Label>
                </p>
              </form>
            </div>
          </Form.Group>

          <Button
            variant="primary"
            type="submit"
            disabled={loading}
            className={`${styles.pay_update_btn} pay_update_btn`}
          >
            {loading ? 'Please Wait...' : 'Update'}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

PaymentSettingsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  control: PropTypes.element.isRequired,
  onHide: PropTypes.func.isRequired,
  register: PropTypes.element.isRequired,
  onSubmit: PropTypes.func.isRequired,
  webhookUrl: PropTypes.string.isRequired,
};

export default PaymentSettingsModal;
